import React, { useState, useEffect } from 'react';
import { Header, Footer } from './Container';
import {
	Container,
	Row,
	Col,
	Card,
	Form,
	ListGroup,
	Modal,
	Button,
} from 'react-bootstrap';
import clockLogo from '../assets/images/clock-regular.svg';
import '../assets/css/Cogen.css';
import { ReqGet, ReqPost } from '../config/Requests';
import moment from 'moment';
import _ from 'lodash';
import Spinner from './UI/Spinner/Spinner';
import ReactPaginate from 'react-paginate';
import { useNavigate, Link } from 'react-router-dom';

function Notifications() {
	const navigate = useNavigate();
	const styles = {
		title: {
			cursor: 'pointer',
		},
	};
	const [archivedNotificationList, setArchivedNotificationList] = useState([]);
	const [checkedItem, setCheckedItems] = useState([]);
	const [hide, setHide] = useState(true);
	const [totalPages, setTotalPages] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);
	const [offset, setOffset] = useState(0);

	const [request, setRequest] = useState({
		isInitiated: false,
		isSuccess: false,
		isFailed: false,
	});
	const archivedNotificationData = () => {
		setRequest({ isInitiated: true });
		ReqGet(`notifications/archived?page=${currentPage}`)
			.then(res => {
				setTotalPages(res.data.total / 10);
				setArchivedNotificationList(res.data.data);
				setRequest({ isInitiated: false, isSuccess: true });
				if (checkedItem && checkedItem.length > 0) {
					const list = res.data.data.map(item => item.id);
					console.log(list);
					setCheckedItems(list);
				} else {
					setCheckedItems([]);
				}
			})
			.catch(err => {
				console.log(err.response);
				setRequest({ isSuccess: false, isFailed: true });
			});
	};
	useEffect(() => {
		archivedNotificationData();
	}, [currentPage, offset]);

	const handlePageClick = e => {
		const selectedPage = ++e.selected;
		const offset = selectedPage * 10;
		setCurrentPage(selectedPage);
		setOffset(offset);
	};

	const selectedUnarchiveHandler = () => {
		ReqPost('/notifications/restore', { ids: checkedItem })
			.then(res => {
				console.log(res.data);
				window.location.reload();
			})
			.catch(err => {
				alert(err.message);
			});
	};

	useEffect(() => {
		if (checkedItem.length === 0) {
			setHide(true);
		} else {
			setHide(false);
		}
	}, [checkedItem]);

	const selectAllChangeHandler = event => {
		if (event.target.checked === false) {
			setCheckedItems([]);
			return;
		}
		const list = archivedNotificationList.map(item => item.id);
		setCheckedItems(list);
	};

	const selectChangeHandler = (event, id) => {
		const list = _.cloneDeep(checkedItem);
		if (event.target.checked === false && list.indexOf(id) !== -1) {
			_.remove(list, i => i === id);
		} else {
			list.push(id);
		}
		setCheckedItems(list);
	};
	const userDetail = item => {
		if (
			item.type.includes('QuestionClientNotify') ||
			item.type.includes('NotifyClientToAnswer') ||
			item.type.includes('NotifyClientToShortlist') ||
			item.type.includes('NotifyClientToExtendTime')
		) {
			if (typeof item.data.job !== 'undefined') {
				console.log(item);
				let notificationId = [item.id];
				ReqPost('/notifications/mark-as-read', { ids: notificationId })
					.then(res => {
						console.log(res.data);
					})
					.catch(err => {
						alert(err.message);
					});
				navigate(`job/${item.data.job.id}/applicants_question`, {
					params: { data: item.data.job },
				});
			} else {
				navigate(`job/${item.data.job.id}/applicant`, {
					params: { data: item.data.job },
				});
			}
		} else {
			navigate(`job/${item.data.job.id}/applicants`, {
				params: { data: item.data.job },
			});
		}
	};
	return (
		<Container fluid='true'>
			<Header type='member' />
			<Container className='flex-column mt-5 notification align-content-inherit'>
				<Link to='/notifications/0'>
					<Button variant='outline-primary btn-back-main'>Back</Button>
				</Link>
				<br />
				<h2>Archived Notifications</h2>
				<div>
					<Form.Check
						inline
						label='Select All'
						type='checkbox'
						className='mr-5'
						checked={
							archivedNotificationList.length === 0
								? false
								: _.size(archivedNotificationList) === _.size(checkedItem)
						}
						onChange={selectAllChangeHandler}
					/>
				</div>
				<div className='col-md-6'>
					<Button
						className=''
						onClick={selectedUnarchiveHandler}
						variant='success'
						disabled={hide}
					>
						Unarchived Selected
					</Button>
				</div>
				{request.isInitiated === true ? <Spinner /> : null}
				{request.isSuccess === true &&
					archivedNotificationList.length === 0 && (
						<p>No Archived Notifications</p>
					)}
				<ListGroup className='mt-3'>
					{archivedNotificationList.map(item => {
						const timeCreated = moment(item.created_at).fromNow();
						return (
							<div key={item.data.job.id}>
								{/* <Card key={item.data.job.id} className="mt-3 mb-2 shadow-sm">
                  <Card.Body>
                    <Row>
                      <Card.Title className="text-primary normal p-1 " style={{ marginLeft: '1%' }}>
                        {item.data.job.id + '. ' + item.data.job.title}
                      </Card.Title>
                    </Row>


                    <ListGroup.Item
                      key={item.data.job.id}
                      className="d-flex justify-content-between align-items-center pl-0 pr-0 border-left-0 border-right-0"
                    >
                      <Row>
                        <Form.Check
                          inline
                          label=""
                          type="checkbox"
                          checked={checkedItem.indexOf(item.id) !== -1}
                          onChange={(event) => selectChangeHandler(event, item.id)}
                        />
                        <Col>
                          <p
                            className={
                              item.read_at === null ? "mb-0 fw-bold" : "mb-0"
                            }
                            style={styles.title}
                            onClick={() => navigate(`/job/${item.data.job.id}/applicants`)}
                          >
                            {item.data.message}
                          </p>
                          {item.read_at === null ? (
                            <div>
                              <span className="dot"></span>
                              <img
                                className="clock-logo"
                                src={clockLogo}
                                alt="clock"
                              />
                              <span className="fw-bold">{timeCreated}</span>
                            </div>
                          ) : (
                            <div>
                              <img
                                className="clock-logo"
                                src={clockLogo}
                                alt="clock"
                              />
                              <span>{timeCreated}</span>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  </Card.Body>
                </Card> */}
								<Card key={item.data.job.id} className='mt-3 mb-2 shadow-sm'>
									<Card.Body>
										<Row>
											<Card.Title
												className='text-primary normal p-1 '
												style={{ marginLeft: '1%' }}
											>
												{item.data.job.id + '. ' + item.data.job.title}
											</Card.Title>
										</Row>
									</Card.Body>
									<ListGroup className='mt-3'>
										<ListGroup.Item
											key={item.data.job.id}
											className='d-flex justify-content-between align-items-center pl-0 pr-0 border-left-0 border-right-0'
										>
											<Row style={{ marginLeft: '2%' }}>
												<Form.Check
													inline
													label=''
													type='checkbox'
													checked={checkedItem.indexOf(item.id) !== -1}
													onChange={event =>
														selectChangeHandler(event, item.id)
													}
												/>
												<Col>
													<p
														className={
															item.read_at === null
																? 'mb-0 fw-bold'
																: 'mb-0'
														}
														style={styles.title}
														onClick={() => userDetail(item)}
													>
														{item.data.message}
													</p>
													{item.read_at === null ? (
														<div>
															<span className='dot'></span>
															<img
																className='clock-logo'
																src={clockLogo}
																alt='clock'
															/>
															<span className='fw-bold'>
																{timeCreated}
															</span>
														</div>
													) : (
														<div>
															<img
																className='clock-logo'
																src={clockLogo}
																alt='clock'
															/>
															<span>{timeCreated}</span>
														</div>
													)}
												</Col>
											</Row>
											{/* <div>
                          <img src={archiveLogo} alt="" className="pr-4 logo" onClick={() => { notificationArchiveHandler(item) }} />
                          <img src={deleteLogo} alt="" className="pr-4 logo" onClick={() => { notificationDeleteHandler(item) }} />
                        </div> */}
										</ListGroup.Item>
									</ListGroup>
								</Card>
							</div>
						);
					})}
				</ListGroup>
				<br /> <br />
				<ReactPaginate
					previousLabel={'previous'}
					nextLabel={'next'}
					breakLabel={'...'}
					breakClassName={'break-me'}
					pageCount={totalPages}
					marginPagesDisplayed={2}
					pageRangeDisplayed={5}
					onPageChange={handlePageClick}
					containerClassName={'pagination'}
					activeClassName={'active'}
					pageLinkClassName='page-link'
					breakLinkClassName='page-link'
					nextLinkClassName='page-link'
					previousLinkClassName='page-link'
					pageClassName='page-item'
					nextClassName='page-item'
					renderOnZeroPageCount={null}
					previousClassName='page-item'
				/>
			</Container>
			<Footer />
		</Container>
	);
}
export default Notifications;
